import { render, staticRenderFns } from "./crearJuego_sopa.vue?vue&type=template&id=5bcc09c6"
import script from "./crearJuego_sopa.vue?vue&type=script&lang=js"
export * from "./crearJuego_sopa.vue?vue&type=script&lang=js"
import style0 from "./crearJuego_sopa.vue?vue&type=style&index=0&id=5bcc09c6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports